export type LogLevel = 'debug' | 'info' | 'warning' | 'error';
